import { API_BASE_URL } from "modules/shared/shared.configs";
export var profileUrl = API_BASE_URL + "/users/me";
export var logoutUrl = API_BASE_URL + "/auth/signout";
